import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_text = _resolveComponent("base-text")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, _mergeProps({
    "is-visible": true,
    title: $props.title,
    "show-action-close": ""
  }, $setup.listeners, {
    onActionClose: $options.onClose,
    "data-qa": `${$props.currentKey}`
  }), {
    actions: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass($options.actionsWrapperClasses)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.actionItems, (action) => {
          return (_openBlock(), _createBlock(_component_base_text, {
            key: action.key,
            as: "span",
            class: "_tc--accent _ttl _cur-p",
            onClick: $event => ($options.onChange(action.key))
          }, {
            default: _withCtx(() => [
              (action.showLeft)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 0,
                    name: "chevron-left",
                    "icon-namespace": "fa",
                    class: "_mr-1",
                    "data-qa": "previous"
                  }))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(action.text) + " ", 1 /* TEXT */),
              (action.showRight)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 1,
                    name: "chevron-right",
                    "icon-namespace": "fa",
                    class: "_ml-1",
                    "data-qa": "next"
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString($props.text) + " ", 1 /* TEXT */),
        _createVNode(_component_base_text, {
          as: "a",
          class: "gfu-link gfu-link--accent",
          href: $props.learnMoreUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          "data-qa": "learn-more"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMoreButton) + ".", 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["title", "onActionClose", "data-qa"]))
}